import { Routes, Route } from "react-router-dom";
import QSetList from "./list";
import AddQSet from "./add";
import UploadSolution from "./uploadSolution";
// import EditQSet from './edit';
import ViewQSet from "./view";
import UploadQuestion from "./uploadQuestion";
import CompareQSet from "./compare";
import UploadQuestionNew from "./addNew";
import AiQuestionList from "./questions";
import UploadSolutionNew from "./uploadSolutionNew";
import EditQSet from "./edit";
import UploadTheoryQuestionsOnly from "./addNewTho";
import UploadBookQuestionSolution from "./addNewBook";
// import TaskUpload from '../task/view/TaskUpload';
// import ViewTask from '../task/view/ViewTask';

const QSet = () => {
  return (
    <Routes>
      <Route path="/" element={<QSetList />} />
      <Route path="/add" element={<AddQSet />} />
      <Route path="/edit/:id" element={<EditQSet />} />
      <Route path="/view/:id" element={<ViewQSet />} />
      <Route path="/solution/:id" element={<UploadSolution />} />
      <Route path="/solution-new/:id" element={<UploadSolutionNew />} />
      <Route path="/question/:id" element={<UploadQuestion />} />
      <Route path="/question-new/:id" element={<UploadQuestionNew />} />
      <Route
        path="/question-new-tho/:id"
        element={<UploadTheoryQuestionsOnly />}
      />
      <Route
        path="/question-new-book/:id"
        element={<UploadBookQuestionSolution />}
      />
      <Route path="/questions" element={<AiQuestionList />} />
      <Route path="/compare/:id" element={<CompareQSet />} />
      {/* <Route path="/taskUpload/:id" element={<ViewTask />} />
      <Route path="/taskUpload/questions/:id" element={<TaskUpload />} /> */}
    </Routes>
  );
};

export default QSet;
